import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ShopInfoEdit.css';

function CategorySettings() {
  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    Promise.all([fetchAllCategories(), fetchSelectedCategories()])
      .then(() => setLoading(false));
  }, []);

  const fetchAllCategories = async () => {
    try {
      const res = await axios.get('/api/categories');
      setAllCategories(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchSelectedCategories = async () => {
    const tg = window.Telegram.WebApp;
    try {
      const res = await axios.get('/api/merchant/categories', {
        headers: { 'x-telegram-init-data': tg.initData }
      });
      setSelectedCategories(res.data.categories || []);
    } catch (err) {
      console.error(err);
    }
  };

  const toggleCategory = (catId) => {
    if (selectedCategories.includes(catId)) {
      setSelectedCategories(selectedCategories.filter(id => id !== catId));
    } else {
      setSelectedCategories([...selectedCategories, catId]);
    }
  };

  const saveCategories = async () => {
    setSaving(true);
    setMessage('');
    const tg = window.Telegram.WebApp;
    try {
      await axios.post('/api/merchant/categories', { categories: selectedCategories }, {
        headers: { 'x-telegram-init-data': tg.initData }
      });
      setMessage('保存成功');
    } catch (err) {
      setMessage('保存失败：' + (err.response?.data?.error || err.message));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="shop-info-edit-container" style={{ textAlign: 'center', padding: '40px' }}>加载中...</div>;

  return (
    <div className="shop-info-edit-container">
      <h2>分类设置（系统分类）</h2>
      <p>选择您店铺提供的菜品大类，如“中餐”、“西餐”、“饮品”等，顾客可按大类筛选商家。</p>
      <div className="shop-info-form">
        <div className="form-group">
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '20px' }}>
            {allCategories.map(cat => (
              <label key={cat.id} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <input
                  type="checkbox"
                  checked={selectedCategories.includes(cat.id)}
                  onChange={() => toggleCategory(cat.id)}
                />
                {cat.name}
              </label>
            ))}
          </div>
        </div>
        <button className="submit-btn" onClick={saveCategories} disabled={saving}>
          {saving ? '保存中...' : '保存分类'}
        </button>
        {message && <p className="form-message">{message}</p>}
      </div>
    </div>
  );
}

export default CategorySettings;